<template>
    <main-content-wrapper>
        <h1 class="text-md-center">
            REGISTRACIJA
            <span>Registrirajte se s Tuš Cash & Carry klub kartico in koristite morebitne pogodbene popuste.</span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <split-content text="Registrirajte se s Tuš Cash & Carry klub kartico" />
                <empty-space />
                <v-alert
                        :value="invalid_no_selection"
                        type="warning"
                >
                    Za nadaljevanje izberite eno izmed možnosti.
                </v-alert>
                <empty-space v-if="invalid_no_selection" />
                <image-option-selector2 v-model="selected_option" option1="Imam Tuš Cash & Carry klub kartico in želim koristiti morebitne pogodbene bonitete" :option1_image="require('../assets/existing-card.png')" option2="Registracija brez Tuš Cash & Carry kartice"  :option2_image="require('../assets/new-card.png')" />
                <empty-space />
                <v-btn depressed large block color="primary_action" @click="goNext">POTRDI</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import ImageOptionSelector2 from "../components/ImageOptionSelector2";
    import Router from '../router';
    import utils from "../store/utils";

    export default {
        name: "CreateAccountSelect",
        components: {MainContentWrapper, SplitContent, ImageOptionSelector2, EmptySpace},
        data: vm => ({
            invalid_no_selection: false,
            selected_option: undefined
        }),
        computed: {
            authenticated: utils.vuexBuildSetGet(this, 'auth', 'authenticated'),
            authenticated_user: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user'),
        },
        watch: {
            authenticated: function(){
                this.checkAccess()
            }
        },
        methods: {
            checkAccess(){
                if (this.authenticated && this.authenticated_user.connected_account_is_temp == false) {
                    Router.push('/racun');
                }
            },
            goNext(){
                if (this.selected_option == '1'){
                    Router.push('/ustvari/kartica');
                } else if (this.selected_option == '2'){
                    this.invalid_no_selection = false;
                    Router.push('/ustvari/podjetje');
                } else {
                    this.invalid_no_selection = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>